/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { ReactNode } from "react";
import Container from "@/src/components/Container/Container";
import Grid from "@mui/material/Grid";
import teaserWithCardsStyle from "./teaserWithCardsStyle";
import { Box, Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import { SxProps } from "@mui/system";
import { gaEvent } from "@/src/services/googleAnalyticsService";
import { Link } from "react-router";

type TeaserWithCardsProps = {
  hasTeaserButton?: boolean;
  teaserButtonText?: string;
  teaserButtonLink?: string;
  teaserButtonType?: any;
  teaserButtonOnClick?: Function;
  headline: string | ReactNode;
  secondHeadline?: string;
  subheadline?: ReactNode;
  sx?: SxProps;
  children?: ReactNode;
};

const LandingPageTeaser = ({
  hasTeaserButton = true,
  teaserButtonText = "Jetzt kostenlos starten",
  teaserButtonLink = "#top-checkin",
  teaserButtonType = Link,
  teaserButtonOnClick = () => {},
  headline,
  secondHeadline,
  subheadline = "Wir helfen Ihnen einfach, schnell und professionell. Egal wann und wo!",
  sx = teaserWithCardsStyle.marginTop,
  children,
}: TeaserWithCardsProps) => {
  const handleTeaserButtonClick = () => {
    gaEvent({
      category: "Button Click",
      action: "Teaser Start",
    });
    teaserButtonOnClick();
  };

  return (
    <Container showVerticalPadding={false} sx={sx}>
      <Box id="jetzt-starten" />
      <Grid
        container
        wrap={"nowrap"}
        sx={[{
          alignContent: "center",
          alignItems: "center",
          justifyContent: "space-between"
        }, teaserWithCardsStyle.gridContainer]}>
        <Grid size={12}>
          <Typography variant={"h2"} component={"h1"} id="teaser-headline" sx={teaserWithCardsStyle.gridItemText}>
            {headline}
          </Typography>
          {secondHeadline && (
            <Typography variant={"h4"} sx={teaserWithCardsStyle.gridItemText}>
              {secondHeadline}
            </Typography>
          )}
          {subheadline && (
            <Typography variant={"h6"} component={"p"} id="teaser-subheadline" sx={teaserWithCardsStyle.gridItemText}>
              {subheadline}
            </Typography>
          )}
          {hasTeaserButton && (
            <Box sx={teaserWithCardsStyle.buttonContainer}>
              <Button
                component={teaserButtonType}
                to={teaserButtonLink}
                sx={teaserWithCardsStyle.startButton}
                onClick={handleTeaserButtonClick}
                color={"primary"}
                variant={"contained"}
              >
                {teaserButtonText}
              </Button>
            </Box>
          )}
        </Grid>
      </Grid>
      {children ?? null}
    </Container>
  );
};
export default LandingPageTeaser;
